import { Directive, ElementRef, inject, Injectable, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Directive({
    selector: '[safetranslate]',
    standalone: false
})
export class SafeTranslateDirective implements OnInit, OnChanges {
  // needs same name as selector to be able to do: safetranslate="translation.key"
  // this value has priority over innerHTML
  @Input() safetranslate = ''; 

  // example safetranslate="Request.Status.DaysToReadableText.Selected_Months" [translateParams]="{months: true ? 2 : 3}"
  @Input() translateParams:any; 
  

  constructor(private el: ElementRef, private translateService: TranslateService, private safeTranslateInjectable: SafeTranslateInjectable) {
    this.translate()
  }
  // translate on init
  ngOnInit(): void {
    this.translate()
  }
  
  // translate on change
  ngOnChanges(changes: SimpleChanges): void {
    this.translate()
  }

  private translate(){
    let translationKey:string = this.safetranslate;
    if(!translationKey) // if input has not been set use innerHTML
      translationKey = this.el.nativeElement.innerHTML;
    if(translationKey){
      this.el.nativeElement.innerHTML = this.safeTranslateInjectable.translate(translationKey, this.translateParams)
    }
  }
}

@Injectable({
  providedIn: "root"
})
export class SafeTranslateInjectable{

  constructor(private translateService: TranslateService) {
  }

  public translate(translationKey:string, translateParams:any=null) {
    if(translationKey == undefined || !translationKey) return;

    let translation = this.translateService.instant(translationKey, translateParams)
      if (translationKey !== translation) {
        return translation;
      }else{
        let splitValue:string[] = translation.split(".")
        if(splitValue.length>1 && splitValue[splitValue.length-1])
          return splitValue[splitValue.length-1];
      }
  }
}
